// Package 4, part M (owner, 7. 10. 2026; "Rebrand: AFTER DAY"): the move to the new address. On an old address (the
// installed app still opens it) a card covers the game: AFTER DAY has a new home, and one tap goes there signed in. On
// the new address, a player whose notifications were on at the old one gets a card to turn them back on, and to put
// the game on the Home Screen again (the old icon opens the old address).

import { useState } from 'react';
import { BRAND } from '@lastday/shared';
import { useMe } from '@/api/hooks';
import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui';
import { toast } from '@/components/Toast';
import { t } from '@/i18n';
import { enablePush, needsHomeScreen } from '@/lib/push';

export function NewHomeCard() {
  const me = useMe().data;
  const home = me?.features.newHome;
  if (!home) return null;
  const go = () => {
    // Signed in: the server hands a one-time token to the new address; otherwise straight there.
    window.location.href = me?.user ? `/api/auth/carry-out?next=${encodeURIComponent(window.location.pathname)}` : `${home}${window.location.pathname}`;
  };
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-bg/95 p-6" role="dialog" aria-modal aria-labelledby="new-home-title" data-testid="new-home">
      <div className="flex w-full max-w-[440px] flex-col items-center gap-4 rounded-[10px] border border-line bg-surface p-6 text-center">
        <Logo kind="symbol" height={64} />
        <h1 id="new-home-title" className="display m-0 text-[26px] font-bold leading-tight">
          {t('common.move.title', { name: BRAND.name })}
        </h1>
        <p className="m-0 text-[15px] leading-[22px] text-text">{t('common.move.body', { domain: BRAND.domain })}</p>
        <Button full onClick={go} data-testid="new-home-go">
          {t('common.move.go')}
        </Button>
      </div>
    </div>
  );
}

export function PushAgainCard() {
  const me = useMe().data;
  const [hidden, setHidden] = useState(false);
  if (!me?.user?.pushAgain || !me.features.push || hidden) return null;
  const on = async () => {
    const ok = await enablePush().catch(() => false);
    if (ok) {
      toast.info(t('common.move.pushOn'));
      setHidden(true);
    } else toast.info(t('common.move.pushNo'));
  };
  return (
    <section className="flex flex-col gap-2 rounded-[6px] border border-border bg-surface p-4" data-testid="push-again">
      <span className="display text-[18px] font-semibold">{t('common.move.pushTitle', { name: BRAND.name })}</span>
      <span className="text-[14px] leading-5 text-text">{t('common.move.pushBody', { domain: BRAND.domain })}</span>
      {needsHomeScreen() && <span className="text-[13px] leading-[18px] text-muted">{t('common.move.homeScreen', { name: BRAND.name })}</span>}
      <span className="flex flex-wrap gap-2">
        <Button size="sm" onClick={on} data-testid="push-again-on">
          {t('common.move.pushButton')}
        </Button>
        <Button size="sm" variant="ghost" onClick={() => setHidden(true)}>
          {t('common.move.later')}
        </Button>
      </span>
    </section>
  );
}
